import { Flex, Tabs } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import TitleSection from "../../Components/TitleSection/TitleSection"
import { referralsSubtitle, useQuery } from "../../Utils/utils"
import Earnings from "./Earnings"
import Invite from "./Invite"
import WithdrawalsHistoryButton from "./Outsiders/components/WithdrawalsHistory/WithdrawalsHistoryButton"

const content = {
  Invite: <Invite />,
  Earnings: <Earnings />
}

const TabsItems = [
  { key: "Invite", label: "Invite" },
  { key: "Earnings", label: "Earnings" }
]

export const ReferralsUserPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { search } = useLocation()
  const query = useQuery(search)
  const { userInfo } = useSelector((state) => state.auth)
  const { isMobile } = useSelector((state) => state.nav)
  const id = query.get("id") ?? "Invite"

  function handleNavigate(subPage) {
    navigate(`?id=${subPage}`)
  }

  return (
    <div>
      <TitleSection
        icon="referrals"
        title="Referral program"
        description={referralsSubtitle[id]}
        style={{ margin: isMobile ? "-16px -16px 16px" : "-32px -32px 24px" }}
      >
        {id === "Earnings" && userInfo?.referral_outsider && <WithdrawalsHistoryButton />}
      </TitleSection>
      <Flex align="flex-end">
        <Tabs
          activeKey={id}
          defaultActiveKey="1"
          className="custom-tab"
          items={TabsItems}
          onChange={(key) => handleNavigate(key)}
        />
        <div className="line full" />
      </Flex>
      <div style={{ padding: "24px 0" }}>{content[id]}</div>
    </div>
  )
}

export default ReferralsUserPage
